import { getRequest, postRequest, deleteRequest, getProposalID } from './api'
import { API_URL } from '../constants/index'

// id: the proposal the saga asked for (it compares the answer with it); default = the
// proposal on screen.
export async function list(id) {
  const url = new URL(`${API_URL}proposalTravelCost`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  const proposalID = id || getProposalID()

  if (proposalID !== null && proposalID !== undefined) {
    searchParams.append('proposalID', proposalID)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`proposalTravelCost/${id}`)
}

export async function save(values) {
  return postRequest(`proposalTravelCost`, values)
}

export function remove(id) {
  return deleteRequest(`proposalTravelCost/${id}`)
}
